export default "__VITE_ASSET__cpOhUngD__"